module.exports = __webpack_public_path__ + "img/postback-step-5.en.ea7c93f5.jpg";